import { IconButton } from "@loot-os/design-system/core/IconButton";
import { Menu, MenuItem, MenuSeparator } from "@loot-os/design-system/core/Menu";
import logoutIcon from "@loot-os/icons/icons/logout";
import userIcon from "@loot-os/icons/icons/user";
import { useNavigate } from "@tanstack/react-router";

import { navLinksIn, visibleNavItems } from "../lib/nav.js";
import { useSignOut } from "../lib/shopper.js";
import { useTenant } from "../lib/tenant.js";
import { useTerminology } from "../lib/terminology.js";

/**
 * The signed-in shopper's menu at the end of both bars: the links placed in it (`STOREFRONT_NAV_LINKS`'
 * `places`), then signing out, which lands them on the home page.
 */
export function AccountMenu() {
  const signOut = useSignOut();
  const navigate = useNavigate();
  const { hasFeature } = useTenant();
  const links = navLinksIn(visibleNavItems(hasFeature, useTerminology()), "accountMenu");

  return (
    <Menu trigger={<IconButton icon={userIcon} label="Account menu" size="sm" />}>
      {links.map((link) => (
        <MenuItem key={link.to} icon={link.icon} href={link.to}>
          {link.label}
        </MenuItem>
      ))}
      <MenuSeparator />
      <MenuItem
        icon={logoutIcon}
        onClick={() => signOut.mutate(undefined, { onSuccess: () => navigate({ to: "/" }) })}
      >
        Sign out
      </MenuItem>
    </Menu>
  );
}
